import moment from 'moment-mini'

// eg. 01:56:10
const HHmmssRegexp = /\d{2}:\d{2}:\d{2}/g

// eg. 1h56m10s
const hhmmsRegexp = /(\d+)h(\d+)m(\d+)s/

/**
 * Returns timestamp in <unit> from given URL
 * supports multiple formats like
 * - 1h56m10s
 * - 01:56:10
 * - 2302ms
 * @param {string} videoURL
 * @param {string = 'seconds'} unit
 * @return {number | null}
 */
export const getVideoTimestampByUrl = (videoURL, unit = 'seconds') => {
	const queryTimestamp = new URL(videoURL).searchParams.get('t')

	if (!queryTimestamp) {
		return null
	}

	// hhmms format - 1h56m10s
	if (hhmmsRegexp.test(queryTimestamp)) {
		return Math.floor(moment.duration(queryTimestamp.replace(hhmmsRegexp, '$1:$2:$3')).as(unit))
	}

	// HHmmss format - 01:56:10
	if (HHmmssRegexp.test(queryTimestamp)) {
		return Math.floor(moment.duration(queryTimestamp).as(unit))
	}

	const timestampValue = queryTimestamp.match(/^\d+/g)?.[0]
	const timestampUnit = queryTimestamp.match(/[^0-9]+$/g)?.[0]

	if (!timestampValue) {
		return null
	}

	// default seconds
	if (!timestampUnit) {
		return moment.duration(timestampValue, 'seconds').as(unit)
	}

	return Math.floor(moment.duration(timestampValue, timestampUnit).as(unit))
}
